import React from 'react';
import { IConfigContextProps } from '../../contexts/ConfigContext';
import Provider, { IAuthInitialState } from '../provider';
import SocialLoginOptions from './SocialLoginOptions';

export interface ILoginProps {
    configuration: IConfigContextProps;
    routing?: any;
    initialState?: IAuthInitialState;
}

const SocialLoginContainer = ({
    configuration,
    routing,
    initialState,
}: ILoginProps) => {
    return (
        <Provider configuration={configuration} initialState={initialState}>
            <SocialLoginOptions routing={routing} />
        </Provider>
    );
};

export default SocialLoginContainer;
